// Maria, 17 October 2026: the white boxes at the top of the profile.
export const HEADER_BOX_SX = {backgroundColor: '#fff', border: '1px solid #e3e8ef', borderRadius: 2, px: 2, py: 1.5};
